import intlMessagesEN from "./i18n/localization/en.json";
import intlMessagesVi from "./i18n/localization/vi.json";
import initReducer from "./Store/initReducer";

export default {
  name: "Setting",
  dir: "Setting",
  pathRoot: "setting",
  routes: [
    {
      url: "lesson",
      component: "Page/LessonSetting",
      meta: {
        authRoute: true,
      },
      props: {
        title: "Cấu hình trạng thái hoàn thành học liệu | Trắc nghiệm toàn diện",
        titleI18n: "Setting:lessonTab",
      },
    },
    {
      url: "",
      component: "Page",
      meta: {
        authRoute: true,
      },
      props: {
        title: "Thông tin công ty | Trắc nghiệm toàn diện",
        titleI18n: "Setting:title",
      },
    },
  ],
  lang: { vi: intlMessagesVi, en: intlMessagesEN },
  isAuthenticate: true,
  redux: initReducer,
  role: ["quickquiZFullRole"],
};
